import type { SpecsLayerModelPath } from "./types";

const SEPARATOR = "\u001f";

export function makeLayerRuntimeKey(path: SpecsLayerModelPath): string {
  return [
    path.partName,
    path.elementName,
    path.styleName,
    path.layerName ?? "",
  ].join(SEPARATOR);
}

export function makeOutputImageRuntimeId(args: {
  layerKey: string;
  role: "mask" | "highlight";
}) {
  return `${args.layerKey}${SEPARATOR}${args.role}`;
}
